export default {
  methods: {
    changeLang(page) {
      let str = this.$i18n.locale
      if (str === 'zh') {
        this.$i18n.locale = 'en'
        this.$router.push({ path: `/en-us/${page}` })
      } else {
        this.$i18n.locale = 'zh'
        this.$router.push({ path: `/zh-cn/${page}` })
      }
    },
    goLogin(){
      let str = this.$i18n.locale
      if (str === 'zh') {
        this.$router.push({ path: '/zh-cn/login' })
      } else {
        this.$router.push({ path: '/en-us/login' })
      }
    },
    goRegister(){
      let str = this.$i18n.locale
      if (str === 'zh') {
        this.$router.push({ path: '/zh-cn/register' })
      } else {
        this.$router.push({ path: '/en-us/register' })
      }
    },
    syncLocaleFromRouteParams(params) {
      const lang = params.lang || 'en'
      this.$i18n.locale = lang === 'zh-cn' ? 'zh' : 'en'
    },
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.syncLocaleFromRouteParams(to.params)
    })
  },
  beforeRouteUpdate(to, from, next) {
    this.syncLocaleFromRouteParams(to.params)
    next()
  },
}
